import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { API_Tickets_MachineTickets } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Tickets_TicketMeta_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, defaultOf, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { InputAdornment, TextField, Autocomplete } from "@mui/material";
import { printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { empty as empty_1, singleton, append, delay, toList, item } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { loadingIndicatorSmall } from "../ViewHelpers.js";

/**
 * Autocomplete that fetches tickets for a specific machine
 */
export function Components_MachineAutocomplete_68E02856(components_MachineAutocomplete_68E02856InputProps) {
    const onSelect = components_MachineAutocomplete_68E02856InputProps.onSelect;
    const ticketIdOpt = components_MachineAutocomplete_68E02856InputProps.ticketIdOpt;
    const machineId = components_MachineAutocomplete_68E02856InputProps.machineId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const isLoading = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setOpen = patternInput_1[1];
    const isOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(new Int32Array([]));
    const setTicketIds = patternInput_2[1];
    useEffectWithDeps(() => {
        let properties_2;
        let active = true;
        if (!isLoading) {
        }
        else {
            const url = API_Tickets_MachineTickets(machineId, false, false);
            console.debug("Fetching tickets for machine:", machineId);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                setLoading(false);
                if (res.tag === 0) {
                    const tickets = res.fields[0];
                    if (active) {
                        console.debug("Fetched tickets for machine", machineId, ":", tickets);
                        setTicketIds(map_1((ticket) => ticket.Id, tickets, Int32Array));
                    }
                    else {
                        console.warn(some("Fetched tickets for machine"), machineId, "but while not active");
                    }
                }
                else {
                    console.error(some("Failed fetching tickets:"), res.fields[0]);
                }
            });
        }
        return createDisposable(() => {
            active = false;
        });
    }, [isLoading]);
    const dependencies_1 = [isOpen];
    reactApi.useEffect(() => {
        if (!isOpen) {
            setTicketIds(new Int32Array([]));
        }
    }, dependencies_1);
    return MuiHelpers_createElement(Autocomplete, [["value", defaultArg(ticketIdOpt, defaultOf())], ["open", isOpen], ["onOpen", (_arg_2) => {
        setLoading(true);
        setOpen(true);
    }], ["onClose", (_arg_3) => {
        setOpen(false);
    }], ["fullWidth", true], ["isOptionEqualToValue", (option_4) => ((value_11) => (option_4 === value_11))], ["loading", isLoading], ["options", Array.from(patternInput_2[0])], ["getOptionLabel", (ticketId) => toText(printf("#%i"))(ticketId)], ["noOptionsText", ctx.Locale.t("Services.NoMachineTicketOptions")], ["onChange", (_arg_4, v, _arg_1_2) => {
        const ticketIdOpt_1 = v;
        console.debug("Ticket machine autocomplete onChange:", ticketIdOpt_1);
        onSelect(ticketIdOpt_1);
    }], ["renderInput", (props) => {
        const endAdornment = item(1, ["endAdornment", props.InputProps.endAdornment]);
        return MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["label", "Ticket"]), delay(() => singleton(["InputProps", createObj(toList(delay(() => append(Object.entries(props.InputProps), delay(() => {
            let elements;
            return singleton(["endAdornment", MuiHelpers_createElement(InputAdornment, [["position", "end"], (elements = toList(delay(() => append(singleton(endAdornment), delay(() => (isLoading ? singleton(loadingIndicatorSmall()) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elements))])])]);
        })))))]))))))));
    }]]);
}

